import { Form } from "../Support/Form";
import { CostIndex } from "../Payment/CostIndex";
import { axios } from "../Support/axios";

export class Account extends Form {

    constructor(data = {}) {
        super(data);

        this.cost_indexes = false;
        this.account_products = [];
        this.account_discounts = [];
        this.tenants = [];
    }

    hasProducts() {
        return this.account_products && this.account_products.length > 0;
    }

    hasDiscounts() {
        return this.account_discounts && this.account_discounts.length > 0;
    }

    toggleAccountTag(tag) {
        let self = this;

        let element = self.data.account_tags.find((element, index) => {
            if (element.tag === tag) {
                self.data.account_tags.splice(index, 1);
                return element;
            }
        });

        if (element === undefined) {
            self.data.account_tags.push({
                tag: tag,
                account_id: self.data.id
            });
        }

        return new Promise((resolve, reject) => {
            axios.patch('/api/account/' + self.data.id + '/tags', self.data.account_tags)
                .then(response => {
                    self.data = response.data.data;

                    resolve(true);
                })
                .catch(error => {
                    self.setError(error);
                    reject(error);
                });
        });
    }

    index(append = false) {
        let self = this;

        return new Promise((resolve, reject) => {
            let uri = '/api/account?page=' + self.page;

            axios.get(uri, self.data)
                .then(response => {
                    let result = response.data;

                    self.processIndexData(result, append);

                    resolve(true);
                })
                .catch(error => {
                    self.setError(error);
                    reject(error);
                });
        });
    }

    show(id) {
        let self = this;

        return new Promise((resolve, reject) => {
            let uri = '/api/account/' + id;

            axios.get(uri, self.data)
                .then(response => {
                    self.data = response.data.data;

                    resolve(true);
                })
                .catch(error => {
                    self.setError(error);
                    reject(error);
                });
        });
    }

    getCostIndexes() {
        let self = this;

        return new Promise((resolve, reject) => {
            let cost_index = new CostIndex();

            cost_index.all().then(response => {
                self.cost_indexes = cost_index.cost_indexes;

                resolve(true);
            }).catch(error => {
                self.setError(error);
                reject(error);
            });
        })
    }

    getAccountProducts() {
        let self = this;

        return new Promise((resolve, reject) => {
            let uri = '/api/account/' + self.data.id + '/products';

            axios.get(uri, self.data)
                .then(response => {
                    self.account_products = response.data.data;

                    resolve(true);
                })
                .catch(error => {
                    self.setError(error);
                    reject(error);
                });
        });
    }

    getAllProductsAccountHasAccessTo() {
        let self = this;

        return new Promise((resolve, reject) => {
            let uri = '/api/account/' + self.data.id + '/products/all';

            axios.get(uri, self.data)
                .then(response => {
                    let products = response.data.data;

                    resolve(products);
                })
                .catch(error => {
                    self.setError(error);
                    reject(error);
                });
        });
    }

    addAccountProduct(product) {
        let self = this;
        let account_id = self.data.id;

        return new Promise((resolve, reject) => {
            let item = {
                id: null,
                sku: product.sku,
                active: true,
                product: product
            };

            axios.patch( '/api/account/' + account_id + '/products', item)
                .then(response => {
                    self.account_products = response.data.data;

                    self.show(account_id).then(result => {
                        resolve(item);
                    });
                }).catch(error => {
                    self.setError(error);

                    reject(error);
                });
        });
    }

    updateAccountProduct(item) {
        let self = this;
        let account_id = self.data.id;

        return new Promise((resolve, reject) => {
            axios.patch( '/api/account/' + account_id + '/products', item)
                .then(response => {
                    self.account_products = response.data.data;

                    self.show(account_id).then(result => {
                        resolve(item);
                    });
                }).catch(error => {
                    self.setError(error);

                    reject(error);
                });
        });
    }

    removeAccountProduct(item) {
        let self = this;
        let account_id = self.data.id;

        return new Promise((resolve, reject) => {
            axios.delete( '/api/account/' + account_id + '/products/' + item.id)
                .then(response => {
                    self.account_products = response.data.data;

                    self.show(account_id).then(result => {
                        resolve(item);
                    });
                }).catch(error => {
                    self.setError(error);

                    reject(error);
                });
        });
    }

    getAccountDiscounts() {
        let self = this;

        return new Promise((resolve, reject) => {
            let uri = '/api/account/' + self.data.id + '/discounts';

            axios.get(uri, self.data)
                .then(response => {
                    self.account_discounts = response.data.data;

                    resolve(true);
                })
                .catch(error => {
                    self.setError(error);
                    reject(error);
                });
        });
    }

    addProductDiscount(product) {
        let self = this;
        let account_id = self.data.id;

        return new Promise((resolve, reject) => {
            let item = {
                id: null,
                sku: product.sku,
                discount: 0,
                product: product
            };

            axios.patch( '/api/account/' + account_id + '/discounts', item)
                .then(response => {
                    self.account_discounts = response.data.data;

                    self.show(account_id).then(result => {
                        resolve(item);
                    });
                }).catch(error => {
                self.setError(error);

                reject(error);
            });
        });
    }

    updateProductDiscount(item) {
        let self = this;
        let account_id = self.data.id;

        return new Promise((resolve, reject) => {
            axios.patch( '/api/account/' + account_id + '/discounts', item)
                .then(response => {
                    self.account_discounts = response.data.data;

                    self.show(account_id).then(result => {
                        resolve(item);
                    });
                }).catch(error => {
                self.setError(error);

                reject(error);
            });
        });
    }

    removeProductDiscount(item) {
        let self = this;
        let account_id = self.data.id;

        return new Promise((resolve, reject) => {
            axios.delete( '/api/account/' + account_id + '/discounts/' + item.id)
                .then(response => {
                    self.account_discounts = response.data.data;

                    self.show(account_id).then(result => {
                        resolve(item);
                    });
                }).catch(error => {
                self.setError(error);

                reject(error);
            });
        });
    }

    updateCostIndex(event, index = false) {
        let self = this;
        let account = false;

        if (index !== false) {
            account = self.index_data.data[index];
        } else {
            account = self.data;
        }

        return new Promise((resolve, reject) => {
            axios.patch('/api/account/' + account.id + '/cost-index/update', {
                    cost_index: event.target.value
                })
                .then(response => {

                    self.data = response.data.data;

                    if (self.index_data) {
                        self.index_data.data[index] = response.data.data;
                    }

                    resolve(true);
                })
                .catch(error => {
                    self.setError(error);
                    reject(error);
                });
        });
    }

    update() {
        let self = this;
        let account = self.data;

        return new Promise((resolve, reject) => {
            axios.patch('/api/account/' + account.id, self.data).then(response => {
                    self.data = response.data.data;

                    resolve(true);
                })
                .catch(error => {
                    self.setError(error);
                    reject(error);
                });
        });
    }

    isAccountTaggedAs(tag) {
        let result = this.data.account_tags.find(element => element.tag === tag);

        return result !== undefined;
    }

    getTenants() {
        let self = this;

        return new Promise((resolve, reject) => {
            axios.get('/api/tenant', self.data)
                .then(response => {
                    self.tenants = response.data;

                    resolve(true);
                })
                .catch(error => {
                    self.setError(error);
                    reject(error);
                });
        });
    }

}
